import { db, storage } from '@/firebase'
import { restSinNegocio } from "@/utils/restaurantes.utils.js";
import { pointInPolygon } from '@/utils/funciones_auxiliares.js';
import router from '@/router/';

export default {

  getNegocioPropio({ commit, state }) {
    return db.collection('negocios').doc(state.negocioPropio).get()
      .then((r) => {
        if (!r.exists) { Promise.reject("no existe el negocio") }
        var res = r.data();
        res.id = r.id;
        return res;
      })
      .then((item) => {
        var storageRef = storage.ref('imagenes/negocios/' + item.id + '.jpg');
        var storageRef2 = storage.ref('imagenes/negocios/' + item.id + '_listado.jpg');
        var p1 = storageRef.getDownloadURL()
          .then((r) => {
            item.imagen = r;
            return item;
          })
          .catch((e) => {
            item.imagen = false;
            return item;
          })
        var p2 = storageRef2.getDownloadURL()
          .then((r) => {
            item.imagenListado = r;
            return item;
          })
          .catch((e) => {
            item.imagenListado = false;
            return item;
          })

        return Promise.all([p1, p2])
          .then(() => { commit('setNegocioPropioObj', item); })
      })
  },
  getListadoRestaurantes({ commit, state, rootState }) {
    //se toman todos, independientemente del código provincia, para poder usarlso en toda la web
    //let codigoProvincia = rootState.pedido.addressObject.codigoProvincia;
    const negocio = state.negocioPropio;
    return db.collection('restaurantes')
      //.where('codigoProvincia', '==', codigoProvincia)
      .where('negocio', '==', negocio)
      .get()
      .then((r) => {
        console.log(r);
        let res = [];
        if (!r.empty) {
          r.docs.forEach(rest => {
            res.push({
              ...rest.data(),
              id: rest.id
            })
          });
        }
        console.log(res);
        commit('restaurante/setListadoRestaurantes', res, { root: true })
        // commit('setListadoRestaurantes', res)
        return res;
      })
      .catch((e) => {
        console.log(e);
      })
  },
  getListadoRestNegMix({ commit, dispatch, state, rootState }) {
    let codigoRest = rootState.restaurante.listadoRestNegMix.length > 0 ? rootState.restaurante.listadoRestNegMix[0].codigoProvincia : null;
    let codigoProvincia = rootState.pedido.addressObject.codigoProvincia != undefined ? rootState.pedido.addressObject.codigoProvincia : null;

    //Si ya estan cargados los restaurantes de esa provincia no repite llamada
    if (codigoProvincia != codigoRest) {
      return dispatch('getListadoRestaurantes')
        .then(() => {
          const n = state.negocioPropioObj;
          let r = rootState.restaurante.listadoRestaurantes;

          let devolver = [];
          r.forEach((rest) => {
            let found = (n.id == rest.negocio);
            if (found) {
              rest.nombreRest = rest.nombre;
              rest.idRest = rest.id;
              rest.mapeoNeoRest = rest.mapeoNeo;
              let aux = { ...rest, ...n };
              devolver.push(aux);
            }
          });

          if (devolver.length == 0) {
            commit("snackbar/setMensajeDanger",
              { msj: "No se localizan restaurantes por la zona" },
              { root: true }
            );
          }

          commit('restaurante/setListadoRestNegMix', devolver, { root: true })
        })
    } else {
      console.log("no hace falta cargar restaurantes")
    }
  },
  reorderRestaurants({ state, rootState, dispatch }, data) {
    return new Promise((resolve, reject) => {
      let _vue = this;
      let dist = [];
      let position = rootState.pedido.addressObject.coordenadas;
      let restaurantes = state.listadoRestaurantes;

      if (data != undefined) {
        restaurantes = data;
      } else {
        restaurantes = state.listadoRestaurantes;
      }

      restaurantes.forEach(function (e, i) {
        let payload = {
          lat1: position[0],
          lon1: position[1],
          lat2: e.latitud,
          lon2: e.longitud
        }
        dispatch('pedido/getDistanceLatLonInKm', payload, { root: true }).then((e) => {
          restaurantes[i].distancia = e;
        })
      })

      resolve(restaurantes)
    });
  },
  async reordenarRestaurantes({ state, commit }, payload) {

    return new Promise((resolve, reject) => {
      let rest = payload;
      rest.sort((a, b) => a.distancia - b.distancia)
      commit('setListadoRestaurantes', rest)
      resolve(rest)
    })

  },
  elegirRestaurante({ state, rootState, commit, dispatch }, data) {
    let _vue = this;
    let dir = rootState.pedido.addressObject;
    let restaurant = state.listadoRestNegMix.find(r => r.idRest == data)

    //Manda la direccion a caché al elegir el restaurante, solo en domicilio
    if (rootState.pedido.activePedido.forma_envio == "domicilio") {
      if (!dir.cacheada) dir.cacheada = true;
    }
    if (dir.geolocalizacion) delete dir.geolocalizacion
    localStorage.setItem('dirPidiendo', JSON.stringify(dir));



    commit("direcciones/setDirPidiendo", dir, { root: true });
    commit('restaurante/setRestauranteObj', restaurant, { root: true })
    commit("restaurante/setRestaurante", restSinNegocio(restaurant), { root: true });
    commit("restaurante/setNegocio", restaurant.negocio, { root: true });
    commit("pedido/resetCarrito", {}, { root: true });
    commit("restaurante/resetCategorias", {}, { root: true });
    dispatch("navegarPagePedido");
  },


}